module.exports = __webpack_public_path__ + "7986043e3f3675eb803671ad0d744449.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/trickstrat/sketchLogo.png
// module id = 1095
// module chunks = 0